/* eslint-disable import/prefer-default-export */
import config from '@medflex/utils/config';

export const ANCHORS = {
  contactList: {
    physicians: 'contactListPhysicians',
    patients: 'contactListPatients',
    disabled: 'contactListDisabled',
    internal: 'internal',
  },
};

/**
 * Number of seconds between a first and consecutive messages from same sender
 * within messages should be displayed in a special grouped style.
 */
export const SECONDS_GROUP_CONSECUTIVE_MESSAGES = Number(config.SECONDS_GROUP_CONSECUTIVE_MESSAGES);

export const CALL_INFO_CENTER_URLS = {
  videoCallTerms: 'https://medflex.de/hilfe/behandler-datenschutz-und-sicherheit/datenschutz',
  physician: {
    howTo: 'https://medflex.de/hilfe/patienten-video/videosprechstunde-ueber-medflex/',
    howToSchedule: 'https://medflex.de/hilfe/behandler-video/videotermine-durchfuehren/',
  },
  patient: {
    howTo: 'https://medflex.de/hilfe/patienten-video/videosprechstunde-ueber-medflex/',
  },
};

// https://support.tokbox.com/hc/en-us/articles/360029732311-What-is-the-minimum-bandwidth-requirement-to-use-OpenTok-
export const QUALITY_CRITERIA = [
  {
    resolutionPer30FPS: '1280x720',
    minKbps: 100,
    maxPacketLossPercent: 3,
    quality: 'acceptable',
  },
  {
    resolutionPer30FPS: '640x480',
    minKbps: 100,
    maxPacketLossPercent: 3,
    quality: 'acceptable',
  },
  {
    resolutionPer30FPS: '352x288',
    minKbps: 50,
    maxPacketLossPercent: 3,
    quality: 'acceptable',
  },
  {
    resolutionPer30FPS: '320x240',
    minKbps: 50,
    maxPacketLossPercent: 3,
    quality: 'acceptable',
  },
];

export const PRECALL_TEST_URL = `${config.ARZTKONSULTATION_APP_URL}/webapp/#/support `;

export const CALL_RINGING_TONE_TIMEOUT = 30000;

const SALES_BOOKING_URL = 'https://share-eu1.hsforms.com/1jV14bgC2TRet_YZYZwCCqwezx0f';

export const PRACTICE_ADVICE_BOOKING_URL = SALES_BOOKING_URL;
export const DEMO_BOOKING_URL = SALES_BOOKING_URL;

export const UPGRADE_SUBSCRIPTION_PACKAGE_URL = config.UPGRADE_URL;

export const SUBSCRIPTION_PACKAGES_URL = config.PACKAGES_URL;

export const PRICES_URL = 'https://www.medflex.de/preise';

// for these paths header and navigation should be hidden on small screens
export const PATHS_FOR_SIMPLIFIED_UI = ['/chat/:id', '/inbox/requests/:id'];
